import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListTemplateAuthorize = async (param) => {
  let url = `${API_URL.Loader}/api/TemplateAuthorize/GetListTemplateAuthorize`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const InitScreen = async (param) => {
  let url = `${API_URL.Loader}/api/TemplateAuthorize/InitScreen`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const SaveTemplateAuthorize = async (param) => {
  let url = `${API_URL.Loader}/api/TemplateAuthorize/SaveTemplateAuthorize`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DeleteTemplateAuthorize = async (param) => {
  let url = `${API_URL.Loader}/api/TemplateAuthorize/DeleteTemplateAuthorize`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
